/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Component, OnInit } from '@angular/core';
import { RequestsService } from '../services/requests.service';
import { Subscription } from 'rxjs';
import { RequestslistService } from '../services/requestslist.service';
import * as $ from 'jquery';

@Component({
  selector: 'zsd-requests',
  templateUrl: '../view/requests.component.html',
  styleUrls: ['../view/requests.component.scss']
})
export class RequestsComponent implements OnInit {
  isFilterOpen: boolean;
  requestInEditMode: Set<number>;
  addRequestSubscription: Subscription;
  removeRequestSubscription: Subscription;
  requestCount: String;

  constructor(public requestsService: RequestsService, private requestslistService: RequestslistService) {
    this.requestslistService.getRequestCount().subscribe((val: number) => {
      this.requestCount = '(' + val + ')';
  });
    if (!this.requestCount) {
      this.requestCount = '(' + 0 + ')';
    }
   }

  ngOnInit() {
    window.scrollTo(0, 0);
  }
  openFilter() {
    this.isFilterOpen = true;
    $('#requests_filterpanel_control').width('100%');
    $('body').css('overflow-y', 'hidden');
  }
}
